/* eslint-disable */

<template>
  <div>
    <vx-card>
      <!-- ── Tab buttons ── -->
      <div class="flex gap-2 mb-5">
        <vs-button :color="activeTab === 1 ? 'primary' : 'grey'" type="filled" size="small" @click="activeTab = 1"
          >Vulnerability remediation timeframes</vs-button
        >
        <vs-button :color="activeTab === 2 ? 'primary' : 'grey'" type="filled" size="small" @click="activeTab = 2">Environment</vs-button>
        <vs-button :color="activeTab === 3 ? 'primary' : 'grey'" type="filled" size="small" @click="activeTab = 3">Output</vs-button>
      </div>

      <!-- ── Tab 1: Vulnerability remediation timeframes ── -->
      <div v-show="activeTab === 1">
        <!-- CVSS timeframes table -->
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 0.88em; border-radius: 6px; overflow: hidden">
          <thead>
            <tr style="background: #0f1a3a; color: #a0c4ff">
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">CVSS risk level</th>
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">Standard</th>
              <th colspan="3" style="padding: 10px 14px; text-align: center; font-weight: 600; border: 1px solid #1e2a4a">Applies to</th>
            </tr>
            <tr style="background: #0f1a3a">
              <th style="border: 1px solid #1e2a4a"></th>
              <th style="border: 1px solid #1e2a4a"></th>
              <th style="padding: 6px 14px; text-align: center; font-weight: 700; border: 1px solid #1e2a4a; color: #68d391">PROD</th>
              <th style="padding: 6px 14px; text-align: center; font-weight: 700; border: 1px solid #1e2a4a; color: #f6ad55">UAT</th>
              <th style="padding: 6px 14px; text-align: center; font-weight: 700; border: 1px solid #1e2a4a; color: #fc8181">DEV</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in cvssRows" :key="i" :style="{ background: i % 2 === 0 ? '#060c1a' : '#040815' }">
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #a0aec0; white-space: nowrap">{{ row.level }}</td>
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #e2e8f0" v-html="row.standard"></td>
              <td style="padding: 10px 14px; text-align: center; border: 1px solid #181d2a; font-size: 1.1em" v-html="row.prod"></td>
              <td style="padding: 10px 14px; text-align: center; border: 1px solid #181d2a; font-size: 1.1em" v-html="row.uat"></td>
              <td style="padding: 10px 14px; text-align: center; border: 1px solid #181d2a; font-size: 1.1em" v-html="row.dev"></td>
            </tr>
          </tbody>
        </table>

        <!-- Info box -->
        <div
          style="
            background: rgba(0, 83, 255, 0.07);
            border: 1px solid rgba(0, 83, 255, 0.25);
            border-radius: 6px;
            padding: 16px 20px;
            margin-bottom: 24px;
            font-size: 0.88em;
          "
        >
          <p style="color: #63b3ed; font-weight: 600; margin-bottom: 10px">
            Any of these timeframes may be accelerated at the discretion of the Chief Information Security Officer (CISO).
          </p>
          <ul style="padding-left: 20px; line-height: 1.9; color: #a0c4ff; list-style-type: disc !important; list-style-position: outside">
            <li>
              If patching cannot be completed or a vendor has not made a patch available within the timeframe in the table outlined above,
              compensating controls must be put in place within the timeframes listed above and the exception process must be followed.
            </li>
            <li>If a patch requires a reboot for installation, the reboot must occur within the timeframes outlined above.</li>
            <li>All mitigations must be tested in the lower environments before being promoted to production</li>
            <li>
              Appropriate risk management processes should be considered when an applicable timeframe is not required for an environment.
            </li>
          </ul>
        </div>

        <!-- Question panels -->
        <div class="vx-row">
          <!-- Q1: Checkboxes -->
          <div class="vx-col w-5/12">
            <div
              :style="serverCardStyle"
              style="border-radius: 6px; padding: 16px 20px; font-size: 0.88em; height: 100%; background: rgba(255, 255, 255, 0.03)"
            >
              <p class="font-semibold mb-4" style="font-size: 1em">Select the server to be patched within 14 calendar days:</p>
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px 16px">
                <vs-checkbox
                  v-for="srv in serverOptions"
                  :key="srv"
                  v-model="selectedServers"
                  :vs-value="srv"
                  @change="gradedServers = false"
                >
                  {{ srv }}
                </vs-checkbox>
              </div>
            </div>
          </div>

          <!-- Q2: v-select technique -->
          <div class="vx-col w-4/12">
            <div
              style="
                border: 1px solid #181d2a;
                border-radius: 6px;
                padding: 16px 20px;
                font-size: 0.88em;
                height: 100%;
                background: rgba(255, 255, 255, 0.03);
              "
            >
              <p class="font-semibold mb-4" style="font-size: 1em">Select the appropriate technique and mitigation:</p>
              <div :style="selectStyle(technique, correctTechnique, gradedTechnique)">
                <v-select v-model="technique" :options="techniqueOptions" placeholder="Select" @input="gradedTechnique = false" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Tab 2: Environment ── -->
      <div v-show="activeTab === 2">
        <table style="width: 100%; border-collapse: collapse; font-size: 0.88em">
          <thead>
            <tr style="background: #0f1a3a; color: #a0c4ff">
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">Environment name</th>
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">Environment location</th>
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">Subnets</th>
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">Domain</th>
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">Publicly accessible</th>
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">NGFW</th>
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">Load balancer</th>
              <th style="padding: 10px 14px; text-align: left; font-weight: 600; border: 1px solid #1e2a4a">MFA required</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in envRows" :key="i" :style="{ background: i % 2 === 0 ? '#060c1a' : '#040815' }">
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #e2e8f0; font-weight: 600">{{ row.name }}</td>
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #a0aec0">{{ row.location }}</td>
              <td
                style="
                  padding: 10px 14px;
                  border: 1px solid #181d2a;
                  color: #a0aec0;
                  font-family: monospace;
                  font-size: 0.9em;
                  line-height: 1.8;
                "
              >
                <div v-for="s in row.subnets" :key="s">{{ s }}</div>
              </td>
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #a0aec0">{{ row.domain }}</td>
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #a0aec0; text-align: center">{{ row.publicly }}</td>
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #a0aec0; text-align: center">{{ row.ngfw }}</td>
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #a0aec0; text-align: center">{{ row.lb }}</td>
              <td style="padding: 10px 14px; border: 1px solid #181d2a; color: #a0aec0; text-align: center">{{ row.mfa }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ── Tab 3: Output ── -->
      <div v-show="activeTab === 3" style="font-size: 0.88em">
        <div
          v-for="(finding, i) in outputFindings"
          :key="i"
          style="margin-bottom: 20px; padding-bottom: 20px"
          :style="i < outputFindings.length - 1 ? 'border-bottom:1px solid #181d2a' : ''"
        >
          <table style="width: 100%; border-collapse: collapse">
            <tr>
              <td style="padding: 3px 16px 3px 0; color: #fff; font-weight: 700; white-space: nowrap; width: 140px">Title:</td>
              <td class="text-success" style="padding: 3px 0">{{ finding.title }}</td>
            </tr>
            <tr>
              <td style="padding: 3px 16px 3px 0; color: #fff; font-weight: 700; white-space: nowrap">Description:</td>
              <td style="padding: 3px 0; color: #a0aec0">{{ finding.description }}</td>
            </tr>
            <tr>
              <td style="padding: 3px 16px 3px 0; color: #fff; font-weight: 700; white-space: nowrap">Affected asset:</td>
              <td class="text-success" style="padding: 3px 0">{{ finding.asset }}</td>
            </tr>
            <tr>
              <td style="padding: 3px 16px 3px 0; color: #fff; font-weight: 700; white-space: nowrap">Risk:</td>
              <td style="padding: 3px 0; color: #a0aec0">{{ finding.risk }}</td>
            </tr>
            <tr>
              <td style="padding: 3px 16px 3px 0; color: #fff; font-weight: 700; white-space: nowrap">Reference:</td>
              <td class="text-success" style="padding: 3px 0">{{ finding.reference }}</td>
            </tr>
          </table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      activeTab: 1,

      // Q1
      selectedServers: [],
      gradedServers: false,
      correctServers: ['192.168.60.5'],
      serverOptions: ['192.168.76.5', '192.168.76.6', '192.168.50.5', '192.168.50.6', '192.168.60.5', '192.168.60.6'],

      // Q2
      technique: null,
      gradedTechnique: false,
      correctTechnique: 'Patch; upload signed certificate from trusted third-party provider',
      techniqueOptions: [
        'Patch; issue a CRL for the server to the CA',
        'Patch; upload signed certificate from trusted third-party provider',
        'Compensating control; implement MFA on the application',
        'Patch; upgrade IIS to current release',
        'Request exception; legacy protocol could have operational impact',
        'Compensating control; implement secure session tokens',
        'Compensating control; create new ACL on firewall to block port 443',
        'Request exception; organization needs time to procure a PKI',
      ],

      cvssRows: [
        {
          level: 'CVSS > 9.0',
          standard: 'Must be patched or remediated and verified by a subsequent vulnerability scan within <strong>7 calendar days</strong>',
          prod: '<span style="color:#68d391">✔</span>',
          uat: '<span style="color:#68d391">✔</span>',
          dev: '<span style="color:#fc8181">✖</span>',
        },
        {
          level: 'CVSS > 7.9 < 9.0',
          standard:
            'Must be patched or remediated and verified by a subsequent vulnerability scan within <strong>14 calendar days</strong>',
          prod: '<span style="color:#68d391">✔</span>',
          uat: '<span style="color:#fc8181">✖</span>',
          dev: '<span style="color:#fc8181">✖</span>',
        },
        {
          level: 'CVSS > 5.0 < 7.9',
          standard:
            'Must be patched or remediated and verified by a subsequent vulnerability scan within <strong>30 calendar days</strong>',
          prod: '<span style="color:#68d391">✔</span>',
          uat: '<span style="color:#fc8181">✖</span>',
          dev: '<span style="color:#fc8181">✖</span>',
        },
        {
          level: 'CVSS > 0 < 5.0',
          standard:
            'Must be patched or remediated and verified by a subsequent vulnerability scan within <strong>60 calendar days</strong>',
          prod: '<span style="color:#68d391">✔</span>',
          uat: '<span style="color:#fc8181">✖</span>',
          dev: '<span style="color:#fc8181">✖</span>',
        },
      ],

      envRows: [
        {
          name: 'prod.comptia.org',
          location: 'External',
          subnets: ['104.17.18.29', '104.17.18.30', '192.168.60.0/24', '192.168.61.0/24'],
          domain: 'comptia.org',
          publicly: 'Yes',
          ngfw: 'Yes',
          lb: 'Yes',
          mfa: 'No',
        },
        {
          name: 'dev.comptia.org',
          location: 'Internal',
          subnets: ['192.168.76.0/24', '192.168.75.0/24'],
          domain: 'comptia.org',
          publicly: 'No',
          ngfw: 'No',
          lb: 'Yes',
          mfa: 'Yes',
        },
        {
          name: 'uat.comptia.org',
          location: 'External',
          subnets: ['192.168.50.0/24', '192.168.51.0/24'],
          domain: 'comptia.org',
          publicly: 'No',
          ngfw: 'Yes',
          lb: 'Yes',
          mfa: 'Yes',
        },
      ],

      outputFindings: [
        {
          title: 'Microsoft IIS: Unsupported software version detected',
          description: 'The software version detected is no longer supported.',
          asset: '192.168.76.5',
          risk: 'Unpatched software',
          reference: 'CVE-2022-0155, CVSS 9.2',
        },
        {
          title: 'Sensitive cookie in HTTPS session without "secure" attribute',
          description:
            'The secure attribute for sensitive cookies in HTTPS sessions is not set, which could cause the user agent to send those cookies in plaintext over HTTP session.',
          asset: '192.168.76.6',
          risk: 'Session sidejacking',
          reference: 'CVE-2021-0462, CVSS 7.4',
        },
        {
          title: 'Untrusted SSL/TLS Server X.509 certificate',
          description: "The server's TLS/SSL certificate is signed by a certificate authority that is untrusted or unknown.",
          asset: '192.168.76.5 (dev server)',
          risk: 'May allow on-path attackers to insert a spoofed certificate for any distinguished name (DN).',
          reference: 'CVE-2021-1234, CVSS 8.1',
        },
        {
          title: 'Sensitive cookie in HTTPS session without "secure" attribute',
          description:
            'The secure attribute for sensitive cookies in HTTPS sessions is not set, which could cause the user agent to send those cookies in plaintext over HTTP session.',
          asset: '192.168.50.6',
          risk: 'Session sidejacking',
          reference: 'CVE-2021-0462, CVSS 7.4',
        },
        {
          title: 'Untrusted SSL/TLS Server X.509 certificate',
          description: "The server's TLS/SSL certificate is signed by a certificate authority that is untrusted or unknown.",
          asset: '192.168.50.5',
          risk: 'May allow on-path attackers to insert a spoofed certificate for any distinguished name (DN).',
          reference: 'CVE-2021-1234, CVSS 8.1',
        },
        {
          title: 'Missing authentication',
          description: 'Missing authentication allows attacker to log into database server using privileged account.',
          asset: '192.168.60.5',
          risk: 'May allow privileged access to sensitive data.',
          reference: 'CVE-2022-0566, CVSS 5.1',
        },
      ],
    };
  },

  computed: {
    serverCorrect() {
      const sel = [...this.selectedServers].sort();
      const cor = [...this.correctServers].sort();
      return sel.length === cor.length && sel.every((v, i) => v === cor[i]);
    },
    serverCardStyle() {
      const base = 'border-radius:6px;padding:16px 20px;font-size:0.88em;height:100%;border:1px solid ';
      if (!this.gradedServers) return base + '#181d2a;';
      return base + (this.serverCorrect ? '#28C76F;box-shadow:0 0 0 1px #28C76F;' : '#EA5455;box-shadow:0 0 0 1px #EA5455;');
    },
  },

  methods: {
    selectStyle(answer, correct, graded) {
      if (!graded || !answer) return 'border-radius:4px;';
      if (answer === correct) return 'border-radius:4px;box-shadow:0 0 0 2px #28C76F;';
      return 'border-radius:4px;box-shadow:0 0 0 2px #EA5455;';
    },

    markSimulation() {
      this.gradedServers = true;
      this.gradedTechnique = true;

      let score = 0;
      if (this.serverCorrect) score++;
      if (this.technique === this.correctTechnique) score++;

      this.$emit('simulation_update_score', score);
      if (score === 2) return this.$emit('simulation_full_correct', score);
      this.$emit('simulation_getting_there', score);
    },
  },

  components: { vSelect },

  props: {
    data: { type: Object, required: true },
  },
};
</script>
